import styled from "styled-components";

import { FLIGHT_TYPE_CF } from "../../../constants";

export const Wrapper = styled("div")(({ theme, flightType }) => ({
  ...theme.mixins.flexColumn,
  ...(flightType !== FLIGHT_TYPE_CF ? { borderRadius: "0 4px 4px 0" } : { borderRadius: 4 }),
  backgroundColor: theme.palette.white,
  width: 266,
  height: 60,
  position: "relative",
  transition: "all .2s ease",
  border: `1px solid ${theme.palette.border.main}`,

  "&:hover": {
    borderColor: theme.palette.border.dark,
    boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
  },

  [theme.down("xl")]: {
    width: 226,
  },

  [theme.down("lg")]: {
    width: 186,
  },

  [theme.down("md")]: {
    width: flightType !== FLIGHT_TYPE_CF ? "100%" : 248,
  },

  [theme.down("sm")]: {
    width: "100%",
    borderRadius: 4,
  },
}));

// FE-12: раньше свёрнутый селектор был <div onClick> — в него нельзя было
// попасть табом и он не объявлялся как раскрывающийся элемент.
export const Trigger = styled("button")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  alignItems: "stretch",
  width: "100%",
  height: "100%",
  padding: 0,
  border: "none",
  background: "transparent",
  font: "inherit",
  textAlign: "left",
  cursor: "pointer",
}));

export const ClassBlock = styled("div")(({ theme }) => ({
  ...theme.paddings(4, 15, 0),
  fontSize: 12,
  fontWeight: 500,
  color: theme.palette.text.muted,
}));

export const PassengersCountBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexAlignCenter,
  paddingLeft: 15,
  paddingTop: 2,
}));

export const PassengerCount = styled("div")(({ theme }) => ({
  ...theme.paddings(0, 10, 0, 15),
  fontSize: 14,
  position: "relative",

  "& > svg": {
    position: "absolute",
    left: -14,
    top: -10,
  },
}));

export const DropdownIcon = styled("div")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  padding: 4,
  position: "absolute",
  right: 5,
  top: 18,
  color: "#808080",
  transition: "all .3s ease",
  transform: "rotate(0deg)",

  "&.active": {
    transition: "all .3s ease",
    transform: "rotate(180deg)",
  },
}));

export const DropdownPassengersBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  gap: 5,
}));

export const DropdownPassengerItem = styled("div")(({ theme }) => ({
  ...theme.mixins.flexAlignCenter,
}));

export const DropdownPassengerItemTitleAndDescription = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  flexGrow: 1,

  "& .title": {
    fontSize: 12,
    color: theme.palette.black,
  },

  "& .description": {
    fontSize: 10,
    color: theme.palette.text.muted,
  },
}));

export const CounterBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexAlignCenter,

  "& > span": {
    fontSize: 14,
    width: 20,
    textAlign: "center",
    fontVariantNumeric: "tabular-nums",
  },
}));

// FE-12/FE-23: было <svg onClick> — не фокусировалось с клавиатуры и не читалось
// скринридером. Теперь кнопка с зоной нажатия 44x44 при видимом размере иконки 28px.
export const CounterButton = styled("button")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  width: 28,
  height: 28,
  padding: 0,
  border: "none",
  background: "transparent",
  color: theme.palette.text.primary,
  fontSize: 28,
  lineHeight: 1,
  cursor: "pointer",
  position: "relative",
  transition: "color .2s ease",

  "&::after": {
    content: '""',
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: theme.tapTarget,
    height: theme.tapTarget,
  },

  "&:disabled": {
    color: theme.palette.text.disabled,
    cursor: "not-allowed",
  },

  "&:not(:disabled):hover": {
    color: theme.palette.primary.main,
  },
}));

export const ClassesBlock = styled("div")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(2, 1fr)",
  gap: 5,
  paddingTop: 15,
}));

export const ClassButton = styled("button")(({ theme, position }) => ({
  ...(position ? { gridColumn: position } : {}),
  backgroundColor: "transparent",
  color: theme.palette.text.muted,
  border: `1px solid ${theme.palette.border.darker}`,
  borderRadius: 4,
  height: 32,
  cursor: "pointer",
  transition: "all .2s ease",
  fontWeight: 500,

  "&:hover": {
    borderColor: theme.palette.secondary.main,
    color: theme.palette.secondary.main,
    backgroundColor: "#f0f9fc",
  },

  "&.active": {
    backgroundColor: theme.palette.secondary.main,
    borderColor: theme.palette.secondary.main,
    color: theme.palette.white,

    "&:hover": {
      backgroundColor: theme.palette.secondary.dark,
      borderColor: theme.palette.secondary.dark,
    },
  },
}));
